import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr'
import {
  FLAG_GETTING_LEGAL_TICKETS,
  GET_LEGAL_TICKETS,
  CLEAR_LEGAL_TICKETS
} from '../types'
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { LEGAL_TICKET_ENDPOINT } from '../../config/endpoints';

const flagGettingTickets = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LEGAL_TICKETS,
    payload: flag
  });

const clearLegalTickets = () => (dispatch) =>
  dispatch({
    type: CLEAR_LEGAL_TICKETS
  });

const getLegalTickets = async (filters) => async (dispatch) => {
  try {
    dispatch(flagGettingTickets(true));
    const query = filters;
    const url = `${LEGAL_TICKET_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const legalTicktets = await response.json();
    dispatch({
      type: GET_LEGAL_TICKETS,
      payload: legalTicktets
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingTickets(false));
  }
}

const getLegalTicketByDocumentNumber = async ({
  documentSerie,
  documentCode
}) => async (dispatch) => {
  try {
    dispatch(flagGettingTickets(true));
    const query = { documentSerie, documentCode };
    const url = `${LEGAL_TICKET_ENDPOINT}/document-number?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const legalTicktets = await response.json();
    dispatch({
      type: GET_LEGAL_TICKETS,
      payload: legalTicktets
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingTickets(false));
  }
}

const postGenerateExcel =
  async (items) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingTickets(true));
        const url = `${LEGAL_TICKET_ENDPOINT}/actions/export-excel`;
        const response = await fetch(url, { ...DEFAULT_POST_CONFIG, body: JSON.stringify(items) });
        await isErrorResponse(response);
        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = "BOLETOS";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagGettingTickets(false));
      }
    };


export {
  flagGettingTickets,
  clearLegalTickets,
  getLegalTickets,
  postGenerateExcel,
  getLegalTicketByDocumentNumber
} 